import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { Injectable } from '@angular/core';
import { AvailabilityService } from '../availability.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { empty } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityResolverService implements Resolve<any> {
  constructor(private availabilityService: AvailabilityService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   console.log(route.data['list'])
    if (route.data['list']) {
    
      return this.availabilityService.getAvailabilityList().pipe(
        
        catchError((error) => {
        
          return empty();
        })
      );
    }
    else if(route.data['edit']){
    
      return this.availabilityService.getAvailability(route.params.id).pipe(
        catchError((error) => {
         
          return empty();
        })
      );
    }
  }
}